import React from 'react';
import { Star, Lightbulb, Target, ArrowRight } from 'lucide-react';
import { personasData } from '../../data/mock';

const PersonasSection = () => {
  const iconComponents = {
    Star: Star,
    Lightbulb: Lightbulb,
    Target: Target
  };

  const iconColors = {
    Star: 'bg-amber-100 text-amber-600',
    Lightbulb: 'bg-stone-100 text-stone-600',
    Target: 'bg-amber-100 text-amber-700'
  };

  return (
    <section id="personas" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-50 text-amber-700 text-sm font-medium rounded-full mb-4">
            Para Quem é
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            Identifique Seu Perfil
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            O diagnóstico licitatório atende diferentes momentos da sua construtora
          </p>
        </div>

        {/* Personas Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {personasData.map((persona) => {
            const Icon = iconComponents[persona.icon];
            const colorClass = iconColors[persona.icon];
            
            return (
              <div
                key={persona.id}
                className="group relative bg-white rounded-2xl p-6 sm:p-8 border border-stone-200 hover:border-amber-200 hover:shadow-xl transition-all duration-300"
              >
                {/* Icon */}
                <div className={`inline-flex p-3 rounded-xl ${colorClass} mb-5`}>
                  <Icon className="w-6 h-6" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-800 mb-3">
                  {persona.title}
                </h3>
                <p className="text-slate-600 mb-4 leading-relaxed">
                  {persona.description}
                </p>

                {/* Highlight */}
                <div className="flex items-start gap-2 p-4 bg-stone-50 rounded-xl">
                  <ArrowRight className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
                  <span className="text-sm font-medium text-slate-700">
                    {persona.highlight}
                  </span>
                </div>

                {/* Hover Effect Line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-500 to-amber-600 rounded-b-2xl transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PersonasSection;
